<template>
  <el-collapse-item :title="itemData.name" :name="itemData.code">
    <div
      @click="selectOption(article.articleId)"
      v-for="(article, index) in itemData.articleList" 
      :key="index" 
      style="min-height:24px" 
      :class="`flex flex-center pd-tb5 fs-12 bd-tb bd-b pd-lr15 c-pointer ${index === 0 ? 'bd-t' : ''}`">
      {{article.articleTitle}}
    </div>
    <div v-if="itemData.children.length > 0">
      <help-window-menu v-for="(childItem) in itemData.children" @selectOption="selectOption" :key="childItem.code" :itemData="childItem"></help-window-menu>
    </div>
  </el-collapse-item>
</template>

<script>
import HelpWindowMenu from '@/components/Setting/HelpWindowMenu'
export default {
  data() {
    return {
      
    }
  },
  props:{
    itemData:{
      type:Object,
      required:true
    }
  },
  created() {
    console.log(this.itemData)
  },
  methods: {
    selectOption(val){
      this.$emit('selectOption',val)
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  components:{
    'help-window-menu': () => import('@/components/Setting/HelpWindowMenu')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/HelpWindowMenu.vue